import { Currency, Token } from '@kodiak-finance/sdk-core'
import { TokenList } from '@uniswap/token-lists'
import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { RowBetween } from 'components/Row'
import { SectionBreak } from 'components/swap/styleds'
import useTheme from 'hooks/useTheme'
import { AlertCircle, ArrowLeft } from 'react-feather'
import { useAddUserToken } from 'state/user/hooks'
import styled from 'styled-components'
import { CloseIcon, ThemedText } from 'theme'

import TokenImportCard from './TokenImportCard'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;
`

interface ImportProps {
  tokens: Token[]
  list?: TokenList
  onBack?: () => void
  onDismiss?: () => void
  handleCurrencySelect?: (currency: Currency) => void
}

export function ImportToken(props: ImportProps) {
  const { tokens, list, onBack, onDismiss, handleCurrencySelect } = props
  const theme = useTheme()

  const addToken = useAddUserToken()

  // const intersection = new Set(tokens.filter((token) => unsupportedSet.has(token.address)))
  // if (intersection.size > 0) {
  //   return <BlockedToken onBack={onBack} onDismiss={onDismiss} blockedTokens={Array.from(intersection)} />
  // }

  return (
    <Wrapper>
      <AutoColumn gap="14px" style={{ width: '100%', flex: '1 1' }}>
        <RowBetween>
          {onBack ? <ArrowLeft style={{ cursor: 'pointer' }} onClick={onBack} /> : <div />}
          <ThemedText.DeprecatedMediumHeader>Import Token</ThemedText.DeprecatedMediumHeader>
          {onDismiss ? <CloseIcon onClick={onDismiss} /> : <div />}
        </RowBetween>
      </AutoColumn>
      <SectionBreak />
      <AutoColumn gap="md" style={{ marginBottom: '32px' }}>
        <AutoColumn justify="center" style={{ textAlign: 'center', gap: '16px' }}>
          <AlertCircle size={48} stroke={theme.textSecondary} strokeWidth={1} />
          <ThemedText.DeprecatedBody fontWeight={400} fontSize={14}>
            <>
              This token doesn&apos;t appear on the active token list(s). Make sure this is the token that you want to
              trade.
            </>
          </ThemedText.DeprecatedBody>
        </AutoColumn>
        {tokens.map((token) => (
          <TokenImportCard token={token} list={list} key={'import' + token.address} />
        ))}
        <ButtonPrimary
          altDisabledStyle={true}
          $borderRadius="6px"
          padding="8px 16px"
          onClick={() => {
            tokens.map((token) => addToken(token))
            handleCurrencySelect && handleCurrencySelect(tokens[0])
          }}
          className=".token-dismiss-button"
        >
          <>Import</>
        </ButtonPrimary>
      </AutoColumn>
    </Wrapper>
  )
}
